import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'
import { api } from '../lib/api'
import type { User } from '../lib/types'

type AuthCtx = { user: User | null | false; setUser: (u: User | null | false) => void; refresh: () => Promise<void>; logout: () => Promise<void> }
const Ctx = createContext<AuthCtx>(null as unknown as AuthCtx)

// user : null = vérification en cours, false = non connecté
export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null | false>(null)
  const refresh = useCallback(async () => {
    try {
      setUser((await api<{ user: User | null }>('/auth/session')).user ?? false)
    } catch {
      setUser(false)
    }
  }, [])
  useEffect(() => {
    // Retour de la connexion Google : AuthCallback échange d'abord le session_id
    if (window.location.hash.includes('session_id=')) return
    refresh()
  }, [refresh])
  const logout = useCallback(async () => {
    await api('/auth/logout', 'POST').catch(() => null)
    setUser(false)
  }, [])
  return <Ctx.Provider value={{ user, setUser, refresh, logout }}>{children}</Ctx.Provider>
}

export const useAuth = () => useContext(Ctx)
